import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from 'moment';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

import { v4 as uuidv4 } from "uuid";

function ListadoOrdenesCompra() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-91);

    let comp30 = new Date();
  comp30.setDate(comp30.getDate() -30 );
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");
  let compromiso30 = moment(comp30).format("YYYY-MM-DD");

  const [ordenesCompra, setOrdenesCompra] = useState([]);

  const [articulos, setArticulos] = useState([]);
  const [artOC, setArtOC] = useState([]);

  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [selectedFechaCompInicio, setSelectedFechaCompInicio] = useState("");
  const [selectedFechaCompFin, setSelectedFechaCompFin] = useState("");

  const [fecha, setFecha] = useState("");
  const [plazo, setPlazo] = useState("");
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState("");
  const [total_cantidad, setTotalCantidad] = useState("");
  const [numero_orden, setNumeroOrden] = useState("");
  const [moneda, setMoneda] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [selectedProveedorEdit, setSelectedProveedorEdit] = useState("");

  const [articulosOrden, setArticulosOrden] = useState([]);
  const [modalEditArticulosPI, setModalEditArticulosPI] = useState(false);
  const toggleEditArticulosPI = () => setModalEditArticulosPI(!modalEditArticulosPI);
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  // Kasher / Taref e IVA opcional (solo OC nacional)
  const [selectedKasher, setSelectedKasher] = useState("");
  const [kasherEdit, setKasherEdit] = useState("Taref");
  const [aplicaIVAEdit, setAplicaIVAEdit] = useState("No");
  const [tipoEdit, setTipoEdit] = useState("");
  const [total_cantidad_edit, setTotalCantidadEdit] = useState(0);
  const [totalCaptura, setTotalCaptura] = useState(1);

  // const [inputFields, setInputFields] = useState([]);
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      nombre: "",
      cantidad: 0,
      precio: 0,
      total: 0,
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [status, setStatus] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_ORDENES_COMPRA}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allOrdenes = response.data;
        // Array para pagination
        let arrayTabla = allOrdenes
          .sort((a, b) => (a.idOrdenCompra < b.idOrdenCompra ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idOrdenCompra,
              activo: a.is_active,
              fecha: a.fecha,
              plazo: a.plazo,
              fecha_compromiso: a.fecha_compromiso,
              observaciones: a.observaciones,
              total_general: a.total_general,
              proveedores: a.proveedores[0].razon_social,
              idProveedores: a.proveedores[0]._id,
              user: a.user[0].nombre + " " + a.user[0].apellido,
              idUser: a.user[0]._id,
              total_cantidad: a.total_cantidad,
              status: a.status,
              embarcado: a.embarcado,
              moneda: a.moneda,
              autorizado: a.autorizado,
              validado: a.validado,
              tipo: a.tipo,
              kasher: a.kasher || "Taref",
              aplicaIVA: a.aplicaIVA || "No",
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setOrdenesCompra(allOrdenes);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
    .get(`${URL_PROVEEDORES}Tipo/China`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin, status]);


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return [
          a.status,
          a.numero,
          a.fecha,
          a.proveedores,
          a.observaciones,
          a.total_cantidad,
          "$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.total_general) + " " + a.moneda,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 137, 15, 45, 15);
    doc.text(`Listado Ordenes de Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Status",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Cantidad",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    doc.save(`Ordenes-Compra.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return {
          Status: a.status,
          Numero: a.numero,
          Fecha: a.fecha,
          Proveedor: a.proveedor,
          Observaciones: a.observaciones,
          Cantidad: a.total_cantidad,
          Total: a.total_general,
          Moneda: a.moneda
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoOrdenesCompra";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoOrdenesCompra",
        sheetFilter: [
          "Status",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Cantidad",
          "Total",
          "Moneda",
        ],
        sheetHeader: [
          "Status",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Cantidad",
          "Total",
          "Moneda",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return [
          a.status,
          a.numero,
          a.fecha,
          a.proveedores,
          a.observaciones,
          a.total_cantidad,
          "$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.total_general) + " " + a.moneda,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 137, 15, 45, 15);
    doc.text(`Listado Ordenes de Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Status",
          "Numero",
          "Fecha",
          "Proveedor",
          "Observaciones",
          "Cantidad",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ordenes Compra",
          email: mailTo,
          fileName: "ListadoOrdenesCompra.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Ordenes de Compra.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    fecha,
    plazo,
    fecha_compromiso,
    idProveedores,
    total_cantidad,
    total_general,
    observaciones,
    numero_orden,
    idEdit,
    kasher,
    aplicaIVA,
    tipo
  ) {
    setKasherEdit(kasher || "Taref");
    setAplicaIVAEdit(aplicaIVA || "No");
    setTipoEdit(tipo || "");
    setFecha(fecha);
    setPlazo(plazo);
    setFechaCompromiso(fecha_compromiso);
    setSelectedProveedorEdit(idProveedores);
    setTotalCantidad(total_cantidad);
    setTotalGeneral(total_general);
    setObservaciones(observaciones);
    setNumeroOrden(numero_orden);
    setIdEdit(idEdit);
    toggleEdit();
  }

  async function ExcelOCMigracion(
    numero,
    idPDFOC,
  ) {
    await axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              // Articulo: a.articulos[0].SKU,
              // Pack: a.pack,
              // TallasColores: a.tallasColores,
              // Cantidad: a.cantidad,
              // Precio: a.precio,
              // Total: a.total,
              articulosOrden: a._id,
              articulos: a.articulos[0]._id,
              cantidad: a.cantidad,
              cantidadOC: a.cantidad,
              // costo: a.precio,
              // costoTotal: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        var option = {};
  
        option.fileName = `OC-${numero}`;
    
        option.datas = [
          {
            sheetData: dataFinal,
            sheetName: `OC-${numero}`,
            sheetFilter: [
              // "Articulo", 
              // "Cantidad", 
              // "Precio", 
              // "Total"
              "articulosOrden",
              "articulos",
              "cantidad",
              "cantidadOC",
              // "costo",
              // "costoTotal",
            ],
            sheetHeader: [
              // "Articulo", 
              // "Cantidad", 
              // "Precio", 
              // "Total"
              "articulosOrden",
              "articulos",
              "cantidad",
              "cantidadOC",
              // "costo",
              // "costoTotal",
            ],
          },
        ];
    
        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
       
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // async function ExcelOCPI(
  //   numero,
  //   idPDFOC
  // ) {
  //   await axios
  //     .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allArticulosOrden = response.data;
  //       let arrayTabla = allArticulosOrden
  //         .map((a) => {
  //           return {
  //             IdItem: a._id,
  //             SKU: a.articulos[0].SKU,
  //             Nombre: a.articulos[0].nombre,
  //             Precio: a.precio,
  //             PiezasPorCaja: a.articulos[0].piezasPorCaja,
  //             CBM: a.cbm,
  //             Cajas: (a.cantidad / a.articulos[0].piezasPorCaja).toFixed(2),
  //             Cantidad: a.cantidad,
  //             ValorTotal: a.cantidad * a.precio,
  //             TotalCBM: a.cbm * a.cantidad
  //           };
  //         })
  //         .filter(function (el) {
  //           return el != null;
  //         });

  //       let dataFinal = Object.values(arrayTabla);

  //       var option = {};
  
  //       option.fileName = `OC-${numero}`;
    
  //       option.datas = [
  //         {
  //           sheetData: dataFinal,
  //           sheetName: `OC-${numero}`,
  //           sheetFilter: [
  //             "IdItem",
  //             "SKU",
  //             "Imagen",
  //             "Nombre",
  //             "Precio",
  //             "PiezasPorCaja",
  //             "CBM",
  //             "Cajas",
  //             "Cantidad",
  //             "ValorTotal",
  //             "TotalCBM",
  //           ],
  //           sheetHeader: [
  //             "IdItem",
  //             "SKU",
  //             "Imagen",
  //             "Nombre",
  //             "Precio",
  //             "PiezasPorCaja",
  //             "CBM",
  //             "Cajas",
  //             "Cantidad",
  //             "ValorTotal",
  //             "TotalCBM",
  //           ],
  //         },
  //       ];
    
  //       var toExcel = new ExportJsonExcel(option);
  //       toExcel.saveExcel();
       
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }


async function ExcelOCPI(numero, idPDFOC) {
  try {
    const response = await axios.get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });

    let allArticulosOrden = response.data;
    let arrayTabla = allArticulosOrden.map((a) => {
      return {
        IdItem: a._id,
        SKU: a.articulos[0].SKU,
        Nombre: a.articulos[0].nombre,
        Precio: a.precio,
        PiezasPorCaja: a.articulos[0].piezasPorCaja,
        CBM: a.cbm,
        Cajas: parseFloat((a.cantidad / a.articulos[0].piezasPorCaja).toFixed(2)),
        Moneda: a.ordenesCompra[0].proveedores[0].moneda,
        // Cantidad: a.cantidad,
        // ValorTotal: a.cantidad * a.precio,
        // TotalCBM: a.cbm * a.cantidad
      };
    }).filter(el => el != null);

    let dataFinal = arrayTabla.map((item, index) => ({
      ...item,
      // Aquí puedes definir las fórmulas en el formato de Excel
      Cantidad: { f: `E${index + 2} * G${index + 2}` },
      ValorTotal: { f: `D${index + 2} * H${index + 2}` }, // Ejemplo de fórmula
      TotalCBM: { f: `F${index + 2} * H${index + 2}` },
    }));

    let worksheet = XLSX.utils.json_to_sheet(dataFinal, {
      header: [
        "IdItem",
        "SKU",
        "Nombre",
        "Precio",
        "PiezasPorCaja",
        "CBM",
        "Cajas",
        "Cantidad",
        "ValorTotal",
        "TotalCBM",
        "Moneda",
      ]
    });

    let workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `OC-${numero}`);
    
    XLSX.writeFile(workbook, `OC-${numero}.xlsx`);
  } catch (err) {
    console.log(err);
  }
}

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result.split(",")[1]); // solo base64 limpio
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

async function ExcelOCPIIngles(numero, idPDFOC) {
  try {
    const response = await axios.get(
      `${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const allArticulosOrden = response.data || [];

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet(`OC-${numero}`);

    // Encabezados
    const headers = [
      "Image",
      "IdItem",
      "SKU",
      "Name",
      "Price",
      "PicesPerBox",
      "CBM",
      "Boxes",
      "Quantity",
      "TotalValue",
      "TotalCBM",
      "Currency",
    ];

    sheet.addRow(headers);
    sheet.getRow(1).font = { bold: true };

    sheet.columns = [
      { width: 14 }, // Image
      { width: 28 }, // IdItem
      { width: 18 }, // SKU
      { width: 35 }, // Name
      { width: 12 }, // Price
      { width: 14 }, // PicesPerBox
      { width: 12 }, // CBM
      { width: 12 }, // Boxes
      { width: 12 }, // Quantity
      { width: 15 }, // TotalValue
      { width: 15 }, // TotalCBM
      { width: 12 }, // Currency
    ];

    for (let i = 0; i < allArticulosOrden.length; i++) {
      const a = allArticulosOrden[i];

      const rowIdx = i + 2;

      const piezasPorCaja = Number(a?.articulos?.[0]?.piezasPorCaja || 0);
      const cantidad = Number(a?.cantidad || 0);
      const precio = Number(a?.precio || 0);
      const cbm = Number(a?.cbm || 0);

      const boxes =
        piezasPorCaja > 0
          ? parseFloat((cantidad / piezasPorCaja).toFixed(2))
          : 0;

      sheet.addRow([
        "", // imagen
        a?._id || "",
        a?.articulos?.[0]?.SKU || "",
        a?.articulos?.[0]?.nombre || "",
        precio,
        piezasPorCaja,
        cbm,
        boxes,
        { formula: `F${rowIdx}*H${rowIdx}` }, // Quantity = PicesPerBox * Boxes
        { formula: `E${rowIdx}*I${rowIdx}` }, // TotalValue = Price * Quantity
        { formula: `G${rowIdx}*H${rowIdx}` }, // TotalCBM = CBM * Boxes
        a?.ordenesCompra?.[0]?.proveedores?.[0]?.moneda || "",
      ]);

      // Altura de fila para imagen
      sheet.getRow(rowIdx).height = 45;

      // URL default
      let imageUrl = process.env.PUBLIC_URL + "/sinImagen.png";

      // Obtener id del artículo
      const articuloId = a?.articulos?.[0]?._id;

      // Buscar imagen real
      if (articuloId) {
        try {
          const resImg = await fetch(
            `${process.env.REACT_APP_URL_GETMEDIA}/${articuloId}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("app_token")}`,
              },
            }
          );

          if (resImg.ok) {
            const dataImg = await resImg.json();
            if (dataImg?.secure_url) {
              imageUrl = dataImg.secure_url;
            }
          }
        } catch (err) {
          console.warn(`Error obteniendo imagen de artículo ${articuloId}`, err);
        }
      }

      // Insertar imagen
      try {
        const imgRes = await fetch(imageUrl);
        if (!imgRes.ok) {
          console.warn(`No se pudo descargar imagen para fila ${rowIdx}`);
          continue;
        }

        const blob = await imgRes.blob();

        const extension = blob.type.includes("jpeg")
          ? "jpeg"
          : blob.type.includes("png")
          ? "png"
          : blob.type.includes("gif")
          ? "gif"
          : null;

        if (!extension) {
          console.warn(`Formato no compatible en fila ${rowIdx}: ${blob.type}`);
          continue;
        }

        const base64 = await blobToBase64(blob);

        const imageId = workbook.addImage({
          base64,
          extension,
        });

        sheet.addImage(imageId, {
          tl: { col: 0.15, row: rowIdx - 0.9 },
          ext: { width: 55, height: 55 },
        });
      } catch (e) {
        console.warn(`Error insertando imagen en fila ${rowIdx}`, e);
      }
    }

    // Formato numérico
    sheet.getColumn(5).numFmt = "#,##0.00";  // Price
    sheet.getColumn(6).numFmt = "#,##0.00";  // PicesPerBox
    sheet.getColumn(7).numFmt = "#,##0.0000"; // CBM
    sheet.getColumn(8).numFmt = "#,##0.00";  // Boxes
    sheet.getColumn(9).numFmt = "#,##0.00";  // Quantity
    sheet.getColumn(10).numFmt = "#,##0.00"; // TotalValue
    sheet.getColumn(11).numFmt = "#,##0.0000"; // TotalCBM

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `OC-${numero}.xlsx`);
  } catch (err) {
    console.log(err);
  }
}
  async function ExcelOC(
    numero,
    idPDFOC
  ) {
    await axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              IdItem: a._id,
              SKU: a.articulos[0].SKU,
              Item: a.articulos[0].nombre,  
              OrderedPieces: a.cantidad,
              UnitPrice: a.precio,
              // costoTotal: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        var option = {};
  
        option.fileName = `OC-${numero}`;
    
        option.datas = [
          {
            sheetData: dataFinal,
            sheetName: `OC-${numero}`,
            sheetFilter: [
              "IdItem",
              "SKU",
              "Item",
              "OrderedPieces",
              "UnitPrice",
              "QuantityPI",
            ],
            sheetHeader: [
              "IdItem",
              "SKU",
              "Item",
              "OrderedPieces",
              "UnitPrice",
              "QuantityPI",
            ],
          },
        ];
    
        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
       
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function PDFOC(
    fecha,
    plazo,
    fecha_compromiso,
    idProveedores,
    proveedores,
    user,
    total_cantidad,
    total_general,
    moneda,
    observaciones,
    numero,
    idPDFOC,
    aplicaIVA,
    kasher,
  ) {
    await axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async(response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].SKU + "  " + a.articulos[0].nombre,
              cantidad: a.cantidad,
              // precio: a.precio,
              // total: a.total,
              pendiente_embarcar: a.pendiente_embarcar,
              idArticulo: a.articulos[0]._id,
              foto: ""
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);


        dataFinal.map(async (z) => {
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${z.idArticulo}`;
         await axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              if(data.data.secure_url != null){
              z.foto = data.data.secure_url
            }else z.foto = process.env.PUBLIC_URL + "sinImagen.png"
            })
            .catch((err) => {
              console.log(err);
            });
          return z
        })

        setTimeout(() => {

        const data = dataFinal.map((a) => {
          return [
            a.foto,
            a.articulos,
            new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.cantidad),
            // "$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.precio),
            // "$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.total),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF("landscape");
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 137, 15, 45, 15);
        doc.text(`Orden de Compra # ${numero}`, 20, 20);
        doc.setFontSize(12);
        doc.text(`Fecha ${fecha}`, 20, 25);
        doc.text(`Proveedor ${proveedores}`, 20, 30);
        doc.text(`Plazo ${plazo} días Compromiso ${fecha_compromiso}${kasher ? ` · ${kasher}` : ""}`, 20, 35);
        doc.text(`Piezas ${new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_cantidad)}`, 20,40);
        doc.text(`Creado por ${user}`, 20, 45);
        doc.autoTable({
          columnStyles: {
            0: {
              fontSize: .0001,
              cellWidth: 25 // Ajusta el ancho de la primera columna (Foto)
            },
          },
          head: [[
            "Foto", 
            "Articulo", 
            "Cantidad", 
            // "Precio", 
            // "Total"
          ]],
          body: dataPDFLimpia,
          bodyStyles: {
            rowHeight: 22,
          },
          startY: 50,

          didDrawCell: function (data) {
            if (data.column.index === 0 && data.cell.section === "body") {
              var td = data.cell.raw;
              var img3 = td;
              //  var dim = data.cell.height - data.cell.padding('vertical');
              var textPos = data.cell;
              doc.addImage(img3, textPos.x, textPos.y, 20, 20);
            }
          },
          footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          // footStyles: {
          //   fontSize: 12,
          //   fillColor: [255,255,255],
          //   textColor: [0,0,0]
          // },
          // foot: [
          //   [
          //     "",
          //     "",
          //     "",
          //     "Total",
          //     "$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_general),
          //   ],
          // ],
          showFoot: "lastPage",
        });
        window.open(doc.output("bloburl"), "_blank");
//doc.save(`OC-${numero}.pdf`);
        
      }, 1000);

      })
      .catch((err) => {
        console.log(err);
      });
  }

    async function PDFOCCostos(
    fecha,
    plazo,
    fecha_compromiso,
    idProveedores,
    proveedores,
    user,
    total_cantidad,
    total_general,
    moneda,
    observaciones,
    numero,
    idPDFOC,
    aplicaIVA,
    kasher,
  ) {
    await axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async(response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].SKU + "  " + a.articulos[0].nombre,
              cantidad: a.cantidad,
              precio: a.precio,
              total: a.total,
              pendiente_embarcar: a.pendiente_embarcar,
              idArticulo: a.articulos[0]._id,
              foto: ""
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);


        dataFinal.map(async (z) => {
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${z.idArticulo}`;
         await axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              if(data.data.secure_url != null){
              z.foto = data.data.secure_url
            }else z.foto = process.env.PUBLIC_URL + "sinImagen.png"
            })
            .catch((err) => {
              console.log(err);
            });
          return z
        })

        setTimeout(() => {

        const data = dataFinal.map((a) => {
          return [
            a.foto,
            a.articulos,
            new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.cantidad),
            "$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.precio),
            "$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.total),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF("landscape");
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 137, 15, 45, 15);
        doc.text(`Orden de Compra # ${numero}`, 20, 20);
        doc.setFontSize(12);
        doc.text(`Fecha ${fecha}`, 20, 25);
        doc.text(`Proveedor ${proveedores}`, 20, 30);
        doc.text(`Plazo ${plazo} días Compromiso ${fecha_compromiso}${kasher ? ` · ${kasher}` : ""}`, 20, 35);
        doc.text(`Piezas ${new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_cantidad)}`, 20,40);
        doc.text(`Creado por ${user}`, 20, 45);
        doc.autoTable({
          columnStyles: {
            0: {
              fontSize: .0001,
              cellWidth: 25 // Ajusta el ancho de la primera columna (Foto)
            },
          },
          head: [[
            "Foto", 
            "Articulo", 
            "Cantidad", 
            "Precio", 
            "Total"
          ]],
          body: dataPDFLimpia,
          bodyStyles: {
            rowHeight: 22,
          },
          startY: 50,

          didDrawCell: function (data) {
            if (data.column.index === 0 && data.cell.section === "body") {
              var td = data.cell.raw;
              var img3 = td;
              //  var dim = data.cell.height - data.cell.padding('vertical');
              var textPos = data.cell;
              doc.addImage(img3, textPos.x, textPos.y, 20, 20);
            }
          },
          footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          // footStyles: {
          //   fontSize: 12,
          //   fillColor: [255,255,255],
          //   textColor: [0,0,0]
          // },
          foot: (aplicaIVA === "Si"
            ? [
                ["Subtotal", total_general],
                ["IVA 16%", total_general * 0.16],
                ["Total", total_general * 1.16],
              ]
            : [["Total", total_general]]
          ).map(([etiqueta, valor]) => [
            "",
            "",
            "",
            etiqueta,
            "$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor),
          ]),
          showFoot: "lastPage",
        });
        window.open(doc.output("bloburl"), "_blank");
//doc.save(`OC-${numero}.pdf`);
        
      }, 1000);

      })
      .catch((err) => {
        console.log(err);
      });
  }


  function editOrdenes(event) {
    event.preventDefault();
    const URL_ORDENES_COMPRA_EDIT = `${process.env.REACT_APP_URL_ORDENES_COMPRA}/${idEdit}`;
    axios
      .all([
        axios.patch(
          URL_ORDENES_COMPRA_EDIT,
          {
            fecha,
            plazo,
            fecha_compromiso,
            proveedores: selectedProveedorEdit,
            total_cantidad,
            total_general,
            observaciones,
            kasher: kasherEdit,
            // el IVA (16%) solo aplica a la OC nacional
            aplicaIVA: tipoEdit === "Nacional" ? aplicaIVAEdit : "No",
            iva: tipoEdit === "Nacional" && aplicaIVAEdit === "Si" ? Number((parseFloat(total_general) * 0.16).toFixed(2)) : 0,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        ),
      ])
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Orden deCompra",
            detalle: `${numero_orden} ${fecha}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Observaciones", field: "observaciones", sortable: true },
    { name: "Fecha Compromiso", field: "fecha_compromiso", sortable: true },
    { name: "Proveedor", field: "proveedores", sortable: true },
    { name: "K / T", field: "kasher", sortable: true },
    { name: "Cantidad", field: "total_cantidad", sortable: true },
    { name: "Embarcado", field: "embarcado", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Moneda", field: "moneda", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
    { name: "Editar", field: "editar", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.proveedores.toLowerCase().includes(search.toLowerCase()) ||
          comment.moneda.toLowerCase().includes(search.toLowerCase()) ||
          comment.total_cantidad.toString().includes(search) ||
          comment.embarcado.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedores.includes(selectedProveedor)
      );
    }
    if (selectedKasher) {
      computedComments = computedComments.filter((e) => e.kasher === selectedKasher);
    }
    if (status) {
      computedComments = computedComments.filter((e) =>
        e.status.includes(status)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    if (selectedFechaCompInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha_compromiso >= selectedFechaCompInicio
      );
    }

    if (selectedFechaCompFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha_compromiso <= selectedFechaCompFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_cantidad" &&
      sorting.field != "embarcado" &&
      sorting.field != "total_general" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "embarcado" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "embarcado" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    status,
    selectedFechaInicio,
    selectedFechaFin,
    selectedProveedor,
    selectedKasher,
  ]);
// console.log("hola", articulosOrden)
  function EditArticulos(idOC, numero_orden) {
    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        nombre: "",
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
    setIdEdit(idOC);
    setNumeroOrden(numero_orden);
    axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0]._id,
              SKU: a.articulos[0].SKU,
              nombre: a.articulos[0].nombre,
              cantidad: a.cantidad,
              cantidadAnterior: a.cantidad,
              precio: a.precio,
              precioOriginal: moneda == "USD" ? a.articulos[0].costoUSD : a.articulos[0].costoMX,
              total: a.total,
              pendiente_embarcar: a.pendiente_embarcar,
              embarcado: a.embarcado,
              cbm: a.cbm,
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setArticulosOrden(dataFinal);

        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleEditArticulos();
  }

  function EditArticulosPI(idOC, numero_orden, moneda) {
    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        nombre: "",
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
    setIdEdit(idOC);
    setNumeroOrden(numero_orden);
    setMoneda(moneda);
    axios
      .get(`${URL_ARTICULOS_OC}/ordenesCompra/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0]._id,
              SKU: a.articulos[0].SKU,
              nombre: a.articulos[0].nombre,
              cantidad: a.cantidad,
              cantidadAnterior: a.cantidad,
              precio: a.precio,
              precioOriginal: moneda == "USD" ? a.articulos[0].costoUSD : a.articulos[0].costoMX,
              total: a.total,
              pendiente_embarcar: a.pendiente_embarcar,
              embarcado: a.embarcado,
              cbm: a.cbm,
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setArticulosOrden(dataFinal);

        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleEditArticulosPI();
  }

  const handleChangeInputExistentes = (id, event) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  const handleChangeInputExistentesCantidad = (id, event) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        let PR =
          parseFloat(i.pendiente_embarcar) -
          parseFloat(i.cantidad) +
          parseFloat(event.target.value);
        i.pendiente_embarcar = PR;
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  function BuscaArticuloExistentes(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        handleChangeInputExistentesArticulo(id, idArticulo);
      }
    });
  }

  const handleChangeInputExistentesArticulo = (id, idArticulo) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: ultimo.articulos,
        cantidad: 0,
        precio: ultimo.precio,
        total: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cantidadExistentes = articulosOrden.map((c) => parseFloat(c.cantidad));
    let cantidadNuevos = values.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosOrden.map((c) => parseFloat(c.total));
    let importesNuevos = values.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        let FOB = a.costoUSD;
        let nombre = a.nombre;
        handleChangeInputArticulo(id, idArticulo, FOB, nombre);
      }
    });
  }

  const handleChangeInputArticulo = (id, idArticulo, FOB, nombre) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.nombre = nombre;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.precio = FOB;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cantidadExistentes = articulosOrden.map((c) => parseFloat(c.cantidad));
    let cantidadNuevos = inputFields.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosOrden.map((c) => parseFloat(c.total));
    let importesNuevos = inputFields.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  }

  const saveOrdenCompra = async (event) => {
    event.preventDefault();
    toggleProgreso();

    let totalArticulos = inputFields.length + articulosOrden.length;

    const URL_ORDENES_COMPRA_EDIT = `${process.env.REACT_APP_URL_ORDENES_COMPRA}/${idEdit}`;
    try {
      await axios
        .patch(
          URL_ORDENES_COMPRA_EDIT,
          {
            total_general: total_general_edit,
            total_cantidad: total_cantidad_edit,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          inputFields.map((a) => {
            if (a.articulos != "" && a.cantidad > 0) {
              axios
                .post(
                  URL_ARTICULOS_OC,
                  {
                    ordenesCompra: idEdit,
                    articulos: a.articulos,
                    cantidad: parseFloat(a.cantidad),
                    embarcado: 0,
                    pendiente_embarcar: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio),
                    total: parseFloat(a.total),
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Editar Orden de Compra",
                          detalle: `${numero_orden}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
              // cerrar if
            } else {
              totalArticulos = totalArticulos - 1;
              if (totalArticulos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Editar Orden de Compra",
                      detalle: `${numero_orden}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              }
            }
          });

          articulosOrden.map((a) => {
            axios
              .patch(
                `${URL_ARTICULOS_OC}/${a.id}`,
                {
                  articulos: a.articulos,
                  cantidad: parseFloat(a.cantidad),
                  precio: parseFloat(a.precio),
                  total: parseFloat(a.total),
                  // pendiente_embarcar: parseFloat(a.pendiente_embarcar),
                  ajusteAcumulado: parseFloat(a.cantidad - a.cantidadAnterior),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Editar Orden de Compra",
                        detalle: `${numero_orden}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  function excelInfoArt() {

    axios
    .get(`${URL_ARTICULOS_OC}FindAllInfoArt`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allInfoArt = response.data;

      const dataExcel = allInfoArt.map((a) => {
          return {
            Articulo: a.codigo,
            Cantidad: a.cantidad,
            Embarcado: a.embarcado,
            PendienteEmbarcar: a.pendiente_embarcar,
          };
      });
      const dataExportExcel = Object.values(dataExcel);
      const dataExcelLimpia = dataExportExcel.filter(function (el) {
        return el != null;
      });
  
      var option = {};
  
      option.fileName = "Info Articulos OC";
  
      option.datas = [
        {
          sheetData: dataExcelLimpia,
          sheetName: "Info Articulos OC",
          sheetFilter: [
            "Articulo",
            "Cantidad",
            "Embarcado",
            "PendienteEmbarcar",
          ],
          sheetHeader: [
            "Articulo",
            "Cantidad",
            "Embarcado",
            "PendienteEmbarcar",
          ],
        },
      ];
  
      var toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();

    })
    .catch((err) => {
      console.log(err);
    });

  
  }

  function autorizar(id) {
    const URL_AUTORIZADO = `${URL_ORDENES_COMPRA}/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            Swal.fire("Good job!", "Autorizado", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
      }
    });
  }

    function validar(id) {
    const URL_AUTORIZADO = `${URL_ORDENES_COMPRA}/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              validado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            Swal.fire("Good job!", "Validado", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
      }
    });
  }

      function desvalidar(id) {
    const URL_AUTORIZADO = `${URL_ORDENES_COMPRA}/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              validado: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            Swal.fire("Good job!", "Desvalidado", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
      }
    });
  }

      function importarArchivo(event) {
  const target = event.target;
  const name = target.name;
  let hojas = [];

  if (name === "file") {
    let reader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);

    reader.onloadend = (e) => {
      var data = new Uint8Array(e.target.result);
      var workbook = XLSX.read(data, { type: "array" });

      workbook.SheetNames.forEach(function (sheetName) {
        var XL_row_object = XLSX.utils.sheet_to_json(
          workbook.Sheets[sheetName]
        );
        hojas.push({
          data: XL_row_object,
          sheetName,
        });
      });

      let A1 = hojas[0].data;
      let TC = totalCaptura;

      A1.forEach((a) => {
        TC = TC + 1;
        setTotalCaptura(TC);

        const cantidad = a.Cantidad || a.Quantity || 0;
        const precio = a.Precio || a.Price || 0;
        const total = cantidad * precio;
        const pendiente_embarcar = cantidad;
        const cbm = a.CBM || a.Cbm || a.cbm || 0;

        const existingItemIndex = articulosOrden.findIndex(item => item.id === a.IdItem);

        const itemData = {
          cantidad,
          precioOrigonal: articulosOrden.precioOriginal,
          precio,
          total,
          embarcado: 0,
          pendiente_embarcar,
          cbm,
        };

        if (existingItemIndex !== -1) {
          articulosOrden[existingItemIndex] = {
            ...articulosOrden[existingItemIndex],
            ...itemData,
          };
        } else {
          articulosOrden.push({
            id: uuidv4(),
            articulos: a.IdItem,
            ...itemData,
          });
        }
      });

      ActualizaTotales();
    };
  }
}


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_compras ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.oc_create ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/OrdenesCompraCreate"
                >
                  Nueva Orden
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Orden
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excelInfoArt}
                >
                  Excel Info Art <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ordenes de Compra</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ordenes de Compra</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Proveedores</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedProveedor}
                onChange={(e) => {
                  setSelectedProveedor(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {proveedores
                  .sort((a, b) => (a.razon_social > b.razon_social ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.razon_social}</option>;
                  })}
              </Input>
            </Col>

            <Col md={2}>
              <Label>Status</Label>
              <Input
                bsSize="sm"
                type="select"
                value={status}
                required
                onChange={(e) => {
                  setStatus(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Abierto">Abierto</option>
                <option value="Cerrado">Cerrado</option>
              </Input>
            </Col>

            <Col md={2}>
              <Label>Kasher / Taref</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedKasher}
                onChange={(e) => {
                  setSelectedKasher(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                <option value="Kasher">Kasher</option>
                <option value="Taref">Taref</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr
                      style={
                        (a.fecha_compromiso < endDate ||
                          a.fecha_compromiso < compromiso30) &&
                        a.status == "Abierto"
                          ? { backgroundColor: "#ed8c8c" }
                          : // : a.fechaCompromiso > compromiso30
                            // ? { backgroundColor: "#fcf260"  }
                            // : { backgroundColor: "#64e379" }
                            undefined
                      }
                    >
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.observaciones}</td>
                      <td>{a.fecha_compromiso}</td>
                      <td>{a.proveedores}</td>
                      <td title={a.kasher === "Kasher" ? "Kasher (con factura)" : "Taref (sin factura)"}>
                        {a.kasher === "Kasher" ? "K" : "T"}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
                          a.total_cantidad
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.embarcado)}
                      </td>
                      <td>
                        {"$" +
                          new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
                            a.aplicaIVA === "Si" ? a.total_general * 1.16 : a.total_general
                          )}{" "}
                        {a.aplicaIVA === "Si" && (
                          <div style={{ fontSize: "0.7rem", opacity: 0.8 }}>IVA incluido</div>
                        )}
                      </td>
                      <td>{a.moneda}</td>
                      <td>
                        {user.menu_compras ? (
                          <div>
                            {user.menu_compras && a.validado == "No" ? (
                              <span>
                                <Button
                                  color="danger"
                                  // id="Baja"
                                  onClick={(e) => validar(a._id)}
                                  size="sm"
                                >
                                  <i class="fas fa-thumbs-up"></i>
                                </Button>
                              </span>
                            ) : (
                              <span>
                                <Button
                                  color="primary"
                                  // id="Baja"
                                  onClick={(e) => desvalidar(a._id)}
                                  size="sm"
                                >
                                  <i class="fas fa-thumbs-up"></i>
                                </Button>
                              </span>
                            )}
                          <Button
  size="sm"
  className="btn"
  color="danger"
  onClick={() =>
    user?.inventarios_costos
      ? PDFOCCostos(
          a.fecha,
          a.plazo,
          a.fecha_compromiso,
          a.idProveedores,
          a.proveedores,
          a.user,
          a.total_cantidad,
          a.total_general,
          a.moneda,
          a.observaciones,
          a.numero,
          a._id,
          a.aplicaIVA,
          a.kasher
        )
      : PDFOC(
          a.fecha,
          a.plazo,
          a.fecha_compromiso,
          a.idProveedores,
          a.proveedores,
          a.user,
          a.total_cantidad,
          a.total_general,
          a.moneda,
          a.observaciones,
          a.numero,
          a._id,
          a.aplicaIVA,
          a.kasher
        )
  }
>
  <i class="far fa-file-pdf"></i>
</Button>

                              {user.inventarios_costos ? (
                                <>
                                 <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) => ExcelOC(a.numero, a._id)}
                            >
                              <i class="far fa-file-excel"></i>
                            </Button>

                            {/* <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) => ExcelOCPI(a.numero, a._id)}
                            >
                              PI E
                            </Button> */}

                            <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) => ExcelOCPIIngles(a.numero, a._id)}
                            >
                              PI I
                            </Button>
                                </>
                              ): (
                                <>
                                 <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              // onClick={(e) => ExcelOC(a.numero, a._id)}
                              disabled
                            >
                              <i class="far fa-file-excel"></i>
                            </Button>

                            {/* <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              // onClick={(e) => ExcelOCPI(a.numero, a._id)}
                              disabled
                            >
                              PI E
                            </Button> */}

                            <Button
                              size="sm"
                              className="btn"
                              color="primary"
                              // onClick={(e) => ExcelOCPIIngles(a.numero, a._id)}
                              disabled
                            >
                              PI I
                            </Button>
                                </>
                              )}
                           

                            {/* <Baja
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={process.env.REACT_APP_URL_ORDENES_COMPRA}
                            /> 
                             <BajaAltaMultiple
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={process.env.REACT_APP_URL_ORDENES_COMPRA}
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_OC}/baja`}
                            />*/}
                            <StatusMultiple
                              idStatus={a._id}
                              status={a.status}
                              URL_STATUS={
                                process.env.REACT_APP_URL_ORDENES_COMPRA
                              }
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_OC}/baja`}
                            />
                          </div>
                        ) : undefined}
                      </td>
                      <td>
                        {a.status == "Abierto" && a.activo == "Si" && user.inventarios_costos ? (
                          <div>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaInfo(
                                  a.fecha,
                                  a.plazo,
                                  a.fecha_compromiso,
                                  a.idProveedores,
                                  a.total_cantidad,
                                  a.total_general,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.kasher,
                                  a.aplicaIVA,
                                  a.tipo
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>
                            {user.inventarios_costos ? (
                              <>
                                <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => EditArticulos(a._id, a.numero)}
                            >
                              <i class="fas fa-cart-plus"></i>
                            </Button>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                EditArticulosPI(a._id, a.numero, a.moneda)
                              }
                            >
                              PI
                            </Button>
                              </>
                            ): (
                              <>
                                <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              // onClick={(e) => EditArticulos(a._id, a.numero)}
                              disabled
                            >
                              <i class="fas fa-cart-plus"></i>
                            </Button>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              // onClick={(e) =>
                                // EditArticulosPI(a._id, a.numero, a.moneda)
                              // }
                                disabled
                            >
                              PI
                            </Button>
                              </>
                            )}
                          
                          </div>
                        ) : (
                          <div>
                            <Button color="info" id="Editar" size="sm" disabled>
                              <i class="far fa-edit"></i>
                            </Button>
                            <Button color="info" id="Editar" size="sm" disabled>
                              <i class="fas fa-cart-plus"></i>
                            </Button>
                            <Button color="info" id="Editar" size="sm" disabled>
                              PI
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar Orden de Compra {numero_orden}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                onChange={(e) => {
                  setFecha(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Proveedor</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedProveedorEdit}
                required
                onChange={(e) => {
                  setSelectedProveedorEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona un Proveedor</option>
                {proveedores
                  .sort((a, b) => (a.razon_social > b.razon_social ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.razon_social}</option>;
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label>Plazo</Label>
              <Input
                type="text"
                placeholder="Plazo"
                value={plazo}
                required
                onChange={(e) => {
                  setPlazo(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Fecha Compromiso</Label>
              <Input
                type="date"
                placeholder="Fecha Compromiso"
                value={fecha_compromiso}
                required
                onChange={(e) => {
                  setFechaCompromiso(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>Kasher / Taref</Label>
              <Input type="select" value={kasherEdit} onChange={(e) => setKasherEdit(e.target.value)}>
                <option value="Kasher">Kasher (con factura)</option>
                <option value="Taref">Taref (sin factura)</option>
              </Input>
            </Col>
            {tipoEdit === "Nacional" && (
              <Col md={4} style={{ display: "flex", alignItems: "flex-end" }}>
                <Label check style={{ marginLeft: 20, marginBottom: 8 }}>
                  <Input
                    type="checkbox"
                    checked={aplicaIVAEdit === "Si"}
                    onChange={(e) => setAplicaIVAEdit(e.currentTarget.checked ? "Si" : "No")}
                  />
                  Lleva IVA (16%)
                </Label>
              </Col>
            )}
          </Row>
          <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
            {/* <Col md={4}>
              <h4 id="logoutBoton">
              TOTALES {total_cantidad} pzas. / {"$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_general)}
              </h4>
              </Col> */}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editOrdenes}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalEditArticulos}
        toggle={toggleEditArticulos}
      >
        <ModalHeader toggle={toggleEditArticulos}>
          <h4>Editar Articulos OC {numero_orden}</h4>
          <h4>
            TOTALES {total_cantidad_edit} pzas. /{" "}
            {"$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_general_edit)}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">SKU</Label>
            </Col>
            <Col md={4}>
              <Label className="mr-sm-2">Nombre</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
            {/* <Col md={1}>
              <Label className="mr-sm-2">Embarcado</Label>
            </Col> */}
            {/* <Col md={1}>
              <Label className="mr-sm-2">Por Embarcar</Label>
            </Col> */}
            <Col md={1}>
              <Label className="mr-sm-2">Precio USD</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Total</Label>
            </Col>
          </Row>

          {articulosOrden
            .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
            .map((ao) => (
              <div key={ao.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="articulos"
                      type="select"
                      value={ao.articulos}
                      required
                      onChange={(event) => {
                        BuscaArticuloExistentes(ao.id, event);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {/* La OC se captura por master (al recibir entra a su variante); se deja visible el que ya trae el renglon */}
                      {articulos
                        .filter((a) => a.modelo === "MASTER" || a._id === ao.articulos)
                        .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.SKU}</option>;
                        })}
                    </Input>
                  </Col>
                  <Col md={4}>
                    <Input
                      // bsSize="sm"
                      name="nombre"
                      type="text"
                      placeholder="nombre"
                      value={ao.nombre}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={ao.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInputExistentesCantidad(ao.id, event)
                      }
                    />
                  </Col>
                  {/* <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="embarcado"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="embarcado"
                      value={ao.embarcado}
                      required
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="pendiente_embarcar"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="pendiente_embarcar"
                      value={ao.pendiente_embarcar}
                      required
                      disabled
                    />
                  </Col> */}

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="precio"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Precio"
                      value={ao.precio}
                      required
                      onChange={(event) =>
                        handleChangeInputExistentes(ao.id, event)
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="total"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Total"
                      value={ao.total}
                      disabled
                      onChange={(event) =>
                        handleChangeInputExistentes(ao.id, event)
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}

          {/* Agregar mas articulos */}

          {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={inputField.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticulo(inputField.id, event);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {articulos
                      .filter((a) => a.modelo === "MASTER")
                      .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.SKU}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={4}>
                  <Input
                    // bsSize="sm"
                    name="nombre"
                    type="text"
                    placeholder="nombre"
                    value={inputField.nombre}
                    disabled
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={inputField.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                {/* <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="embarcado"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.embarcado}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="pendiente_embarcar"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.pendiente_embarcar}
                    required
                    disabled
                  />
                </Col> */}

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={inputField.precio}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="total"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Total"
                    value={inputField.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFields}
                    tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
          <Row>
            <Col md={6}>
              <h4 id="logoutBoton">
                TOTALES {total_cantidad_edit} pzas. /{" "}
                {"$" +
                  new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_general_edit)}
              </h4>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={saveOrdenCompra}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalEditArticulosPI}
        toggle={toggleEditArticulosPI}
      >
        <ModalHeader toggle={toggleEditArticulosPI}>
          <h4>Subir PI OC #{numero_orden}</h4>
          <h4>
            TOTALES {total_cantidad_edit} pzas. /{" "}
            {"$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_general_edit)}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <Input
                required
                type="file"
                name="file"
                id="file"
                onChange={(event) => importarArchivo(event)}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Articulos</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">CBM</Label>
            </Col>
            {/* <Col md={1}>
              <Label className="mr-sm-2">Embarcado</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Por Embarcar</Label>
            </Col> */}
            <Col md={1}>
              <Label className="mr-sm-2">Precio Original</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Precio</Label>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Total</Label>
            </Col>
          </Row>

          {articulosOrden.map((ao) => (
            <div key={ao.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={ao.articulos}
                    required
                    disabled
                  >
                    <option value="0">Selecciona</option>
                    {articulos
                      .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.SKU}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={ao.cantidad}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cbm"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="cbm"
                    value={ao.cbm}
                    disabled
                  />
                </Col>
                {/* <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="embarcado"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="embarcado"
                    value={ao.embarcado}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="pendiente_embarcar"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="pendiente_embarcar"
                    value={ao.pendiente_embarcar}
                    required
                    disabled
                  />
                </Col> */}
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precioOriginal"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="PrecioOriginal"
                    value={ao.precioOriginal}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={ao.precio}
                    style={
                      ao.precioOriginal < ao.precio
                        ? { backgroundColor: "#ed8c8c" } // rojo cuando sube
                        : ao.precio < ao.precioOriginal
                        ? { backgroundColor: "#a4e6a4" } // verde cuando baja
                        : {}
                    }
                    disabled
                  />
                </Col>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="total"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Total"
                    value={ao.total}
                    disabled
                  />
                </Col>
              </Row>
            </div>
          ))}

          {/* Agregar mas articulos */}

          {/* {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="articulos"
                    type="select"
                    value={inputField.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticulo(inputField.id, event);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {articulos
                      .filter((a) => a.modelo === "MASTER")
                      .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.SKU}
                          </option>
                        );
                      })}
                  </Input>
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="cantidad"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Cantidad"
                    value={inputField.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="embarcado"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.embarcado}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="pendiente_embarcar"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="NA"
                    value={inputField.pendiente_embarcar}
                    required
                    disabled
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name="precio"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Precio"
                    value={inputField.precio}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name="total"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="Total"
                    value={inputField.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col>
                  <Button
                    size="sm"
                    className="btn"
                    color="danger"
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabindex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>
                  <Button
                    size="sm"
                    className="btn"
                    color="info"
                    onClick={handleAddFields}
                    tabindex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))} */}
          <Row>
            <Col md={6}>
              <h4 id="logoutBoton">
                TOTALES {total_cantidad_edit} pzas. /{" "}
                {"$" +
                  new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_general_edit)}
              </h4>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={saveOrdenCompra}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios segundos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoOrdenesCompra;
